import DashboardLayout from '@/layout/dashboard/DashboardLayout.vue';
// GeneralViews
import NotFound from '@/pages/NotFoundPage.vue';

/* Страницы словаря материалов */
// Словарь материалов
const Materials = () =>
    import('@/pages/Dictionaries/MaterialsList.vue');

/* Страницы словаря работ */
// Словарь работ
const Works = () =>
    import('@/pages/Dictionaries/WorksList.vue');

/* Страницы словаря технологий */
// Словарь технологий
const Technologies = () =>
    import('@/pages/Technologies/TechnologiesList.vue');
// Создание технологии
const TechnologyCreate = () =>
    import('@/pages/Technologies/TechnologyCreate.vue');

const TechnologyUpdate = () => import('@/pages/Technologies/TechnologyUpdate.vue');

/* Страницы словаря проектов */
// Страница проектов
const Projects = () =>
    import('@/pages/Projects/ProjectsList.vue');
// Страница проекта
const Project = () =>
    import('@/pages/Projects/ProjectPage.vue');
// Страница сметы по проекту
const Estimate = () =>
    import('@/pages/Estimates/EstimatePage.vue');
// Страница создания сметы
const EstimateCreate = () =>
    import('@/pages/Estimates/EstimateCreate.vue');
// Страница редактирования сметы
const EstimateUpdate = () =>
    import('@/pages/Estimates/EstimateUpdate.vue');
// Страница диаграммы Гантта по проекту
const Gantt = () =>
    import('@/pages/Gantt/GanttPage.vue');

const routes = [
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/works',
        children: [
            {
                path: 'materials',
                name: 'MaterialsList',
                meta: { title: 'словарь материалов' },
                component: Materials,
            },
            {
                path: 'works',
                name: 'WorksList',
                meta: { title: 'словарь работ' },
                component: Works,
            },
            {
                path: 'technologies',
                name: 'TechnologiesList',
                meta: { title: 'словарь технологий' },
                component: Technologies,
            },
            {
                path: 'technologies/create',
                name: 'TechnologiesCreate',
                meta: { title: 'словарь технологий' },
                component: TechnologyCreate,
            },
            {
                path: 'technologies/update/:technologyId',
                name: 'TechnologiesUpdate',
                meta: { title: 'словарь технологий' },
                component: TechnologyUpdate,
            },
            {
                path: 'projects',
                name: 'ProjectsList',
                meta: { title: 'список проектов' },
                component: Projects,
            },
            {
                path: 'projects/:projectId',
                name: 'ProjectPage',
                meta: { title: 'проект' },
                component: Project,
            },
            {
                path: 'projects/:projectId/estimates/:estimateId',
                name: 'EstimatePage',
                meta: { title: 'смета' },
                component: Estimate,
            },
            {
                path: 'projects/:projectId/estimates/create',
                name: 'EstimateCreate',
                meta: { title: 'смета' },
                component: EstimateCreate,
            },
            {
                path: 'projects/:projectId/estimates/:estimateId/update',
                name: 'EstimateUpdate',
                meta: { title: 'смета' },
                component: EstimateUpdate,
            },
            {
                path: 'projects/:projectId/estimates/:estimateId/gantt',
                name: 'GanttPage',
                meta: { title: 'диаграмма Гантта' },
                component: Gantt,
            },
        ],
    },
    { path: '/:pathMatch(.*)*', component: NotFound },
];

export default routes;
